import {FaHome} from "react-icons/fa";
import React from "react";
import {PropertyIssueModel} from "./PropertyIssueModel";
import {createOrUpdateParkingFee} from "../../service/JobService";


export const PropertyIssue = (props) => {
    const {job} = props;
    const [show, setShow] = React.useState(false);
    const [message, setMessage] = React.useState("")

    const handleSave = (e, propertyIssueData) => {
        e.stopPropagation()
        setMessage("")
        let payload = {
            ...job,
            description: propertyIssueData.description,
            fee: propertyIssueData.fee,
            id: propertyIssueData.id,
            image_ids: propertyIssueData.images.map(image => image.id)
        }
        createOrUpdateParkingFee(payload).then(response => {
            if (response.status === 200) {
                console.log("Parking Fee saved successfully")
                setMessage("Parking Fee saved successfully")
                handleClose(e)
                job.has_parking_fee = payload.fee > 0
            } else {
                response.json().then(data => {
                    setMessage(data.message)
                }).catch(error => {
                    setMessage("Error saving Parking Fee")

                })
                console.log("Parking Fee save failed")
            }
        })
    }
    const totalCount = job.req_deep_clean_count + job.req_fix_count + job.req_key_count

    const checkColor = () => {
        if (totalCount === 0) {
            return 'green';
        }
        if (job.req_fix_count > 0) {
            return 'red';
        }
        if (job.req_key_count > 0) {
            return 'orange';
        }
        if (job.req_deep_clean_count > 0) {
            return 'blue';
        }
    }

    const handleClose = (e) => {
        if (e) {
            e.stopPropagation()
        }
        setMessage("")
        setShow(false)
    }


    return (
        <>
            <FaHome style={{marginLeft: "10px", cursor: "pointer", color: checkColor()}}
                    size={22}
                    title={"Property Issue"}
                    onClick={(e) => {
                        e.stopPropagation()
                        setShow(true)
                    }}
            /> {show &&
            <PropertyIssueModel
                show={show}
                job={job}
                handleSave={handleSave}
                handleClose={handleClose}
                message={message}
                setMessage={setMessage}
            />}
        </>
    )
}
